import React from 'react';
import { Modal, Button, Form, ListGroup, Card } from 'react-bootstrap';

const CustomModal = ({ className, dialogClassName, show, handleClose, title, footer, children }) => {
  return (
    <Modal  className={className} dialogClassName={dialogClassName} show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {footer ? <Modal.Footer>
         <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>: null}
    </Modal>
  );
};

export default CustomModal;